import { render, staticRenderFns } from "./Breadcrum.vue?vue&type=template&id=4df01a54&"
import script from "./Breadcrum.vue?vue&type=script&lang=js&"
export * from "./Breadcrum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports